import { useMessages } from '@/i18n/LocaleProvider';
import messages from '@/i18n/catalogs/corporate/CloudAtCustomerSection';
import React from 'react';

import { Link } from '@/i18n/router';
import { Button } from '@/components/ui/button';
import SectionHeading from '@/components/SectionHeading';
import { ArrowRight, Building2, Fingerprint, GitBranch, Globe2, Lock, ShieldCheck } from 'lucide-react';
import AnimatedSection from './AnimatedSection';

// Homepage teaser for /cloud/at-customer — the deployment option our Cloud at Customer
// customers actually run today. Sits directly under the GizmoData Cloud card.



const CloudAtCustomerSection = () => {
  const m = useMessages(messages);
const points: { icon: React.ElementType; title: string; body: string }[] = [
  { icon: Lock, title: m.s1, body: m.s2 },
  { icon: Globe2, title: m.s3, body: m.s4 },
  { icon: Fingerprint, title: m.s5, body: m.s6 },
  { icon: GitBranch, title: m.s7, body: m.s8 },
];

  return (
    <section id="cloud-at-customer" className="scroll-mt-24 overflow-hidden bg-muted/40 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <AnimatedSection animation="slide-right">
            <div className="space-y-6">
              <span className="inline-flex items-center gap-2 rounded-full border border-gizmo-500/40 bg-gizmo-500/10 px-4 py-1.5 text-sm font-semibold text-gizmo-700 dark:text-gizmo-300">
                <Building2 className="h-4 w-4" />{m.s9}</span>
              <SectionHeading anchor="cloud-at-customer" as="h2" className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">{m.s10}</SectionHeading>
              <p className="text-xl text-muted-foreground leading-relaxed">{m.s11}</p>
              <div className="flex flex-wrap gap-4 pt-2">
                <Link to="/cloud/at-customer">
                  <Button
                    size="lg"
                    className="bg-gizmo-600 text-white hover:bg-gizmo-700 dark:bg-gizmo-500 dark:hover:bg-gizmo-600 font-semibold shadow-lg hover:shadow-xl transition-all hover:-translate-y-0.5"
                    data-ga-cta="view_product"
                    data-ga-location="home_cloud_at_customer"
                  >{m.s12}<ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
                <Link to="/contact?from=home_cloud_at_customer">
                  <Button size="lg" variant="outline" data-ga-cta="contact_sales" data-ga-location="home_cloud_at_customer">{m.s13}</Button>
                </Link>
              </div>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="slide-left">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {points.map(({ icon: Icon, title, body }) => (
                <div key={title} className="rounded-xl border border-border bg-card p-5">
                  <div className="p-2 w-fit bg-gizmo-100 dark:bg-gizmo-900/30 rounded-lg mb-3">
                    <Icon className="h-5 w-5 text-gizmo-600 dark:text-gizmo-400" />
                  </div>
                  <h3 className="font-semibold text-foreground mb-1">{title}</h3>
                  <p className="text-sm text-muted-foreground">{body}</p>
                </div>
              ))}
              <div className="sm:col-span-2 flex items-center gap-3 rounded-xl border border-dashed border-gizmo-500/40 bg-gizmo-500/5 px-5 py-4">
                <ShieldCheck className="h-5 w-5 flex-shrink-0 text-gizmo-600 dark:text-gizmo-400" />
                <p className="text-sm text-muted-foreground">{m.s14}</p>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default CloudAtCustomerSection;
